import { yup } from '@framework/validation/initYup.ts';
import { WidgetType } from '../../../Widget.ts';
import { CommonContainerWidgetConfigSchema } from '../../containers/common/CommonContainerWidgetConfigSchema.ts';
import { type ICompanyWidget } from './ICompanyWidget.tsx';

export const CompanyWidgetConfigSchema: yup.ObjectSchema<ICompanyWidget> =
  CommonContainerWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Company).required(),
  })
    .required()
    .noUnknown();
